module.exports = __webpack_public_path__ + "assets/img/img_money_with_point.8151d3b5.svg";